// extracted by mini-css-extract-plugin
export default {"copyButton":"MinerDataPopover3_copyButton__CMixb","content":"MinerDataPopover3_content__Ie0DO","btn":"MinerDataPopover3_btn__v1r4I"};